import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const semgrep = defineConnector({
  identifier: "semgrep",
  name: "Semgrep",
  tagLine: "Static analysis and code security",
  logo,
  protocol: "http",
  tags: ["security", "engineering"],
  defaultUrlPattern: () => "https://semgrep\\.dev/api/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Semgrep AppSec Platform](https://semgrep.dev), go to **Settings > Tokens > API tokens** and create a new token. Ensure the **Web API** scope is enabled.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://semgrep.dev/api/v1/deployments",
  },
});
